import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {BalanceSelectors} from '@store/balance/balance.selectors';
import {PatronBalanceTransaction} from '@store/balance/balance.types';
import {SelectPipe} from '@aviary/pipes/select.pipe';

@Component({
  selector: 'px-expanded-transaction-opac-note',
  template: `
    <p class="text-title-medium">Details:</p>
    {{ transactionSelectors.opacNoteFor(row) | select }}
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectPipe]
})
export class ExpandedTransactionOpacNoteComponent {

  @Input({required: true}) public row: PatronBalanceTransaction;

  public readonly transactionSelectors = BalanceSelectors.BalanceTransactions;
}
